/*
 * SimpleTableHeader.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Thu Mar 02 2023 mys Company
 */

import { localization } from '../../../config/localize/localizable'
import editSVG from '../../../assets/icons/edit_pencil.svg'
import deleteSVG from '../../../assets/icons/delete.svg'

const SimpleActionTableCells = ({ item, handleEdit, handleDelete, items = [] }) => {
    return (
        <>
            <td>
                {handleEdit && <img className="w-7 h-7 inline-block ml-2 hover:bg-gray-200 rounded p-1" src={editSVG} alt={localization.edit} title={localization.edit} onClick={(e) => handleEdit(e, item)} />}
                {handleDelete && <img className="w-7 h-7 inline-block mr-2 hover:bg-gray-200 rounded p-1" src={deleteSVG} alt={localization.delete} title={localization.delete} onClick={(e) => handleDelete(e, item)} />}
                {items &&
                    items.map((obj, index) => {
                        return (
                            <img
                                key={index}
                                className={`w-7 h-7 inline-block mr-2 hover:bg-gray-200 rounded p-1 ${obj.className}`}
                                src={obj.icon}
                                alt={obj.title}
                                title={obj.title}
                                onClick={(e) => obj.handleClick(e, item)}
                            />
                        )
                    })}
            </td>
        </>
    )
}

export default SimpleActionTableCells
